const addressComponentFields = {
    shortName: 'short_name',
    longName: 'long_name',
}

/**
 * Google Places utility helper for parsing a geocoded address.
 */
class Places {
    static addressComponents = {
        street_number: addressComponentFields.shortName,
        route: addressComponentFields.longName,
        locality: addressComponentFields.longName,
        administrative_area_level_1: addressComponentFields.shortName,
        country: addressComponentFields.shortName,
        postal_code: addressComponentFields.shortName,
    }

    static addressFields = {
        streetNumber: 'street_number',
        route: 'route',
        premise: 'premise',
        locality: 'locality',
        administrativeAreaLevel1: 'administrative_area_level_1',
        postalCode: 'postal_code',
        country: 'country',
    }

    /**
     * Parses the address, city, state, zip code and country
     * from a Place object.
     *
     * @param Array place
     */
    static getAddress(place) {
        let address, city, state, zip, country

        place[0].address_components.forEach((value, index) => {
            switch (value.types[0]) {
                case this.addressFields.streetNumber:
                    address = value[this.addressComponents.street_number]
                    break
                case this.addressFields.route:
                    address = address
                        ? address + ' ' + value[this.addressComponents.route]
                        : value[this.addressComponents.route]
                    break
                case this.addressFields.premise:
                    if (address === null) address = value[this.addressComponents.route]
                    break
                case this.addressFields.locality:
                    city = value[this.addressComponents.locality]
                    break
                case this.addressFields.administrativeAreaLevel1:
                    state = value[this.addressComponents.administrative_area_level_1]
                    break
                case this.addressFields.postalCode:
                    zip = value[this.addressComponents.postal_code]
                    break
                case this.addressFields.country:
                    country = value[this.addressComponents.country]
                    break
                default:
                // Nothing
            }
        })

        if (!city) city = place[0].formatted_address.split(', ')[0]

        return {
            address,
            city,
            state,
            zip,
            country,
        }
    }
}

export default Places
